export class GuideSetting{
    id:number;
    typeId:number;
    url:string;
    
}